define([
  'es6!sumo/util',
  'immutable',
  'underscore',
  'moment',
  'es6!launcher/actions/image-sharer/ImageSharerActions',
], (Util, Immutable, _, moment, Actions) => {
  const initialState = Immutable.Map({
    //  Tracks which settings have been loaded already
    loaded: Immutable.Map({
      settings: false,
      shortener: false,
    }),
    stats: Immutable.Map(),
    settings: Immutable.Map(),
    shortener: Immutable.Map(),
  });

  const actionHandlers = {};

  actionHandlers[Actions.IMAGE_SHARER_UPDATE_SETTING] = (state, action) => {
    const { key, value } = action;
    if (Array.isArray(key)) return state.setIn(key, value);
    return state.set(key, value);
  };

  actionHandlers[Actions.IMAGE_SHARER_RECEIVE_SETTINGS] = (state, action) => {
    const { settings } = action;
    return state.merge(Immutable.fromJS({
      settings,
      loaded: {
        settings: true,
      },
    }));
  };

  actionHandlers[Actions.IMAGE_SHARER_RECEIVE_SHORTENER_SETTINGS] = (state, action) => {
    const { settings } = action;
    return state.merge(Immutable.fromJS({
      shortener: settings,
      loaded: {
        shortener: true,
      },
    }));
  };

  actionHandlers[Actions.IMAGE_SHARER_RECEIVE_STATS] = (state, action) => {
    const { stats } = action;
    return state.mergeIn(['stats'], Immutable.fromJS(stats));
  };

  return Util.createReducer(initialState, actionHandlers);
});
